import gql from 'graphql-tag';
import { PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT } from './PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT';

export const CREATE_PLANOGRAM_ITEM = gql`
	mutation createPlanogramItemMutation(
		$planogramId: ID,
		$planogramItemGroupId: ID,
		$row: Int,
		$column: Int,
		$isIngredient: Boolean,
	) {
		createPlanogramItem (
			planogramId: $planogramId,
			planogramItemGroupId: $planogramItemGroupId,
			row: $row,
			column: $column,
			isIngredient: $isIngredient,
		) {
			...planogramItemPlanogramDetail
		}
	}
	${PLANOGRAM_ITEM_PLANOGRAM_DETAIL_FRAGMENT}
`;

